export default __webpack_public_path__ + "static/media/unsupported-url.69d911c1.svg";